import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {combineLatest, map} from 'rxjs';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {Venue} from 'src/app/models/Venue';
import {NavigationService} from 'src/app/services/navigation.service';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';
import {AppComponent} from '../../../app.component';
import {filterBoardItems} from '../manager-utils/manager-utils';

@Component({
	selector: 'app-manager-header',
	templateUrl: './manager-header.component.html',
	styleUrls: ['./manager-header.component.scss']
})
export class ManagerHeaderComponent implements OnInit {
	@Input() venue: Venue | null;
	@Input() showBack = false;
	@Input() showChip = false;
	@Input() showFaq = false;
	@Input() showNotification = true;
	@Input() showMessages = false;

	@Input() listenShowBack = false;
	@Output() backEvent = new EventEmitter<void>();

	filtersChips = [
		{status: null, quantity: 0, color: '#B0063E', selected: false},
		{
			status: OrderStatus.IN_PREPARATION,
			quantity: 0,
			color: '#FD5E00',
			selected: false
		},
		{status: OrderStatus.READY, quantity: 0, color: '#34A853', selected: false},
		{status: OrderStatus.DONE, quantity: 0, color: '#A9A9A9', selected: false}
	];
	// Counts the same cards the board shows for each chip
	filtersChips$ = combineLatest([
		this.managerFacade.orders$,
		this.managerFacade.ordersPool$,
		this.managerFacade.orderStatusFiler$,
		this.managerFacade.orderChannelsFilter$
	]).pipe(
		map(([orders, pools, status, channels]) => {
			this.filtersChips = this.filtersChips.map(chip => {
				const visible = filterBoardItems(orders, pools, chip.status, channels);
				return {
					...chip,
					selected: status == chip.status,
					quantity: visible.orders.length + visible.pools.length
				};
			});
			return this.filtersChips;
		})
	);
	constructor(
		private managerFacade: ManagerFacade,
		private navService: NavigationService
	) {}

	ngOnInit() {}

	async onBurgerClick() {
		// await this.navService.adminConsole();
		await this.navService.pinCode();
	}

	async navigateBack() {
		if (this.listenShowBack) {
			this.backEvent.emit();
			return;
		}
		this.navService.managerPage();
	}

	getColor(status: string) {
		let defaultColor = '#B0063E';
		switch (status) {
			case OrderStatus.DONE:
				defaultColor = '#A9A9A9';
				break;
			case OrderStatus.READY:
				defaultColor = '#34A853';
				break;
			case OrderStatus.IN_PREPARATION:
				defaultColor = '#FD5E00';
				break;
			default:
				break;
		}
		return defaultColor;
	}
	selectItem(chip: OrderStatus | null) {
		this.managerFacade.setFilterOrderStatus(chip);
	}
	back() {
		this.navService.managerPage();
	}

	protected readonly AppComponent = AppComponent;
}
